import { feedUserSelector } from 'selectors/feedSelectors'
import { connectOptionally, OptionalRendererProps, NO_RENDER, createPositiveRendererProps } from 'tangle-shared'
import FeedUserInfo, { FeedUserInfoStateProps, FeedUserInfoOwnProps } from 'components/features/socialFeed/FeedUserInfo/FeedUserInfo'
import { State } from 'interfaces/state'

const mapStateToProps = (state: State, ownProps: FeedUserInfoOwnProps): OptionalRendererProps<FeedUserInfoStateProps> => {
  const user = feedUserSelector(state, ownProps)
  if (!user) {
    return NO_RENDER()
  }

  const { username, badges } = user

  return createPositiveRendererProps({
    username,
    badges,
  })
}

const FeedUserInfoContainer = connectOptionally<
  FeedUserInfoStateProps, {}, FeedUserInfoOwnProps
>(mapStateToProps, {})(FeedUserInfo)

export default FeedUserInfoContainer
